module.exports = __webpack_public_path__ + "img/1558610.5ecd86db.svg";